import React, { Component } from 'react';
import { array, object, func } from 'prop-types';
import classnames from 'classnames/bind';

import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import { autocompleteSizeMap } from '../../elements/Inputs/common';

import theme from './AutoComplete.css';

class AutoComplete extends Component {
  static propTypes = {
    inputProps: object.isRequired,
    items: array.isRequired,
    renderSuffix: func
  };

  state = {
    suggestions: []
  };

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const { items } = this.props;

    return inputLength === 0 ? [] : items.filter(item =>
      item.text.toLowerCase().slice(0, inputLength) === inputValue
    );
  };

  getSuggestionValue = suggestion => suggestion.text;

  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const { size } = this.props.inputProps;

    const suggestionClass = classnames(
      { 'highlightedItem': isHighlighted },
      theme.autoCompleteItem,
      autocompleteSizeMap[size]
    );

    const suggestionText = suggestion.text;
    const matches = AutosuggestHighlightMatch(suggestionText, query);
    const parts = AutosuggestHighlightParse(suggestionText, matches);

    return (
      <div className={suggestionClass}>
        {parts.map((part, index) => {
          const className = part.highlight ? 'highlightedText' : null;

          return (
            <span className={className} key={index}>
              {part.text}
            </span>
          );
        })}
      </div>
    );
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  handleSuggestionSelect = (e, { suggestion }) => {
    const { onChange } = this.props.inputProps;
    const { text } = suggestion;

    onChange && onChange(text, { origin: 'autocomplete' });
  }

  renderInput = inputProps => {
    const { renderSuffix } = this.props;

    return (
      <div>
        <input {...inputProps} />
        { renderSuffix && renderSuffix() }
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const { inputProps } = this.props;

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionSelected={this.handleSuggestionSelect}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        renderInputComponent={this.renderInput}
        inputProps={inputProps}
        theme={theme}
        highlightFirstSuggestion
      />
    );
  }
}

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/uis/common/AutoComplete/AutoComplete.js